import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { PushButton } from '../components';
import {
  BalanceLabel,
  CapacityLabel,
  DeviceStatusLabel,
  InventoryLabel,
  TargetLabel,
} from '../components/labels';
import { DeviceStatus } from '../../../constants/DeviceStatus';
import { toNumber } from '../../../utils/numbers';
import convertUnit from '../../../utils/unit-converter';
import { BinSwap } from '../components/BinSwap';
import { BinActivation } from '../components/BinActivation';
import {
  Sound,
  Sounds,
} from '../../Sound';
import MaterialVisibilityChange from '../components/MaterialVisibilityChange';
import { WeighedMaterialType } from '../../../constants/MaterialModels';
import {
  getRunMode,
  isRunModeNewYork,
} from '../../../stores/batch/run-mode';

@observer
class BinScrew extends Component {
  render() {
    const { device, batchStore, material, materialDetails, settingsStore, materialStore, onPush, onPushUp, holdFeed, finishFeed, isBinForMultiScale } = this.props;
    const { configuration } = settingsStore;
    const active = batchStore.isOutputOn(device.gateOnePNo);
    const isActive = active ? 'active' : '';
    const deviceStatus = batchStore.getDeviceStatus(device.id);
    const { status, target, error, unit, weight, materialCode } = deviceStatus;
    const runMode = getRunMode(configuration, batchStore);
    const isError = error ? 'error' : '';
    const md = materialDetails || {};
    const isBinActive = md.bins?.some(v => v.isActive && materialStore.binMatchesId(v, device.id));
    const binBalance = md.type === WeighedMaterialType.Cementitious || md.type === WeighedMaterialType.Cement
      ? isBinActive
        ? materialStore.getActiveBinsBalance(material)
        : materialStore.getBinBalance(material, device.id)
      : materialStore.getDevicesBalance(material);
    const name = materialCode || (material ? materialStore.getMaterialName(material) : '');
    const batchUnit = unit || md.itemBatchUnitSymbol;
    const inventoryUnit = material ? material.itemInventoryUnitSymbol : '';
    const scale = batchStore.devicesStore.getDeviceById(device.scaleId);
    const deviceUnit = scale && scale.unitId ? batchStore.getUnitById(scale.unitId) : batchUnit;
    const isDeferenceUnit = batchUnit ? batchUnit !== deviceUnit : false;
    let convertedTarget = target;
    let convertedWeight = weight;
    const isMoreBins = md?.bins?.filter(v => !v.isPrimary && v.isActive).length === 1;
    const isSecondaryBin = md?.bins?.some(v => !v.isPrimary && v.binId === device.id);
    const isLinkedBin = md?.bins?.some(v => v.linkedBinId === device.id);
    const inputDisabled = batchStore.isInputDisabled(device.gateCloseStatusPNo) ? 'device-input-disabled' : '';
    const isBinDisabled = md.bins?.some(v => !v.isActive && (v.binId === device.id || v.linkedBinId === device.id)) ? 'bin-disabled' : '';
    const noScaleError = !scale ? 'no-scale-error' : '';
    const isFeedMode = batchStore.isHoldFeedDevice(device.id)
      || (
        [DeviceStatus.FEED, DeviceStatus.JOG, DeviceStatus.HOLD, DeviceStatus.SETTLING, DeviceStatus.OVER].includes(deviceStatus.status)
        && batchStore.running.length
      );
    const noSwapBins = [DeviceStatus.FEED, DeviceStatus.JOG, DeviceStatus.SETTLING].includes(deviceStatus.status)
      && batchStore.running.length;
    const holdFeedIcon = batchStore.isHoldFeedDevice(device.id) ? 'play' : 'pause';

    if (isDeferenceUnit) {
      convertedTarget = toNumber(convertUnit(target, deviceUnit, batchUnit), 0);
      convertedWeight = toNumber(convertUnit(weight, deviceUnit, batchUnit), 0);
    }

    const binType = isSecondaryBin ? 'secondary' : 'primary';
    const otherMaterials = materialStore.getMaterialsWithTheSameOutput(device.id);

    return (
      <div id={`device-${device.id}`} className={`${isActive} device-gui device-gui--screw device-${isError} ${inputDisabled} ${isBinDisabled} ${noScaleError} device-icon-${device.icon}`}>
        <Sound file={Sounds.alarm} play={!!isError} loop={true}/>
        <MaterialVisibilityChange
          materials={otherMaterials}
          material={material}
          onMaterialClick={m => materialStore.makeMaterialVisible(m, device.id)}
        />
        {!!md.showBalance &&
        <InventoryLabel balance={binBalance} decimal={1} unit={inventoryUnit}/>
        }

        {!!md.showCapacity &&
        <CapacityLabel capacity={device.capacity} decimal={1} unit={inventoryUnit}/>
        }

        <div className="btn-control-feed-wrap">
          {(!isSecondaryBin || isBinForMultiScale) && !isRunModeNewYork(runMode) && !!isFeedMode && !batchStore.isHoldFeed && (
            <button className={'btn-on btn-batch btn-batch-red btn-hold-feed'}
              title={batchStore.isHoldFeedDevice(device.id) ? 'Start feed' : 'Hold feed'}
              onClick={holdFeed}>
              <i className={`fa fa-${holdFeedIcon}`}/>
            </button>
          )}

          {(!isSecondaryBin || isBinForMultiScale) && !isRunModeNewYork(runMode) && !!isFeedMode && batchStore.isHoldFeedDevice(device.id) && (
            <button className={'btn-on btn-batch btn-batch-red btn-finish-feed'}
              title="Finish feed"
              onClick={e => finishFeed(e, material)}>
              <i className={'fa fa-stop'}/>
            </button>
          )}
        </div>

        {!isLinkedBin && !noSwapBins && !isSecondaryBin && material && isMoreBins && (
          <BinSwap onChange={() => {
            materialStore.swapBins(device.id, material, md);
          }}/>
        )}
        {!isLinkedBin && !noSwapBins && isSecondaryBin && material && (
          <BinActivation activeClassName={isBinDisabled} onChange={() => {
            materialStore.toggleBin(device.id, material, md);
          }}/>
        )}

        <div className="device-icon body"/>
        <div className="device-icon drill-wrap">
          <div className="device-icon drill"/>
        </div>
        <div className="device-icon motor"/>
        <div className="device-gui__row">
          {(isBinDisabled && batchStore.running.length) || !device.gateOnePNo || (!configuration.manualFeed && batchStore.running.length) ? '' : (
            <PushButton port={batchStore.maintenanceMode && !configuration.reduceMaintenanceModeInventory ? null : device.gateOnePNo}
              onPush={onPush}
              onPushUp={onPushUp}
              disabled={isRunModeNewYork(runMode)}
              onRightClickHoldLabel={'Hold to keep open..'}
              onRightClickHoldEnd={onPush}
              rightClickHoldDuration={1250}
            />
          )}
        </div>
        <div className="device-labels">
          <DeviceStatusLabel
            name={name}
            status={status}
            description={device.description}
            title={`#${device.id} ${binType} ${inputDisabled} ${noScaleError}`}
            displayIcon={noScaleError}
          />
          <div className="device-label device-label-target">
            <TargetLabel target={convertedTarget} unit={batchUnit} icon={isSecondaryBin ? 'fa' : 'fa fa-crosshairs'}/>
            <BalanceLabel balance={convertedWeight} unit={batchUnit}/>
          </div>
        </div>
      </div>
    );
  }
}

export default BinScrew;
